<mat-card appearance="outlined" class="constraint-card" [class.add-constraint-card]="!existingConstraint" [class.expanded]="expanded">
  @if (!minimal) {
    <mat-card-header (click)="switchExpand()" fxFlex="100%">
      @if (!existingConstraint || expanded) {
        <mat-card-title>
          @if (existingConstraint) {
            {{ 'COMMON.ENTITY.CONSTRAINT' | translate }} #{{ index + 1}}
          } @else {
            <mat-icon color="primary">playlist_add</mat-icon> {{ 'COMMON.CONSTRAINTS.NEW' | translate }}
          }
        </mat-card-title>
      }
      @if (!expanded && existingConstraint) {
        <mat-card-subtitle fxLayout="row wrap" fxLayoutAlign="center center">
          <div fxFlex="0 0 80" class="constraint-text">
            <strong>{{ index + 1 }} -</strong>&nbsp;
            <span [innerHTML]="constraintToText(existingConstraint)"></span>
            @if (constraintWithSources(existingConstraint)) {
              <ul class="sources-list">
                @for (source of existingConstraint.parameters.withSource.value; track source) {
                  <li
                    (click)="openItemfeed($event, source)">
                    {{ source }}
                  </li>
                }
              </ul>
            }
            <!-- Icon to negate/un-negate constraint -->
            @if (existingConstraint && existingConstraint.supportsNegation) {
              @if (selectedConstraint.negated === false) {
                <mat-icon
                  (click)="switchNegated($event)"
                  [matTooltip]="'COMMON.CONSTRAINTS.REVERT.TOOLTIP' | translate"
                color="accent">sync</mat-icon>
              } @else {
                <mat-icon (click)="switchNegated($event)"
                [matTooltip]="'COMMON.CONSTRAINTS.NORMALIZE.TOOLTIP' | translate">sync_problem</mat-icon>
              }
            }
          </div>
          <div fxFlex="0 0 20" class="constraint-actions">
            @if (!selectedConstraint.mandatory) {
              <mat-icon (click)="deleteOldConstraint()" color="warn">delete</mat-icon>
            }
          </div>
        </mat-card-subtitle>
      }
    </mat-card-header>
  }
  <mat-card-content>
    @if (!existingConstraint && expanded) {
      <mat-stepper #stepper orientation="vertical" linear>
        <!-- STEP 1: constraint type selection -->
        <!-- no need for first step if this component is linked to an existing constraint -->
        <mat-step [stepControl]="firstStepGroup" state="constraintChoice">
          <form [formGroup]="firstStepGroup">
            <ng-template matStepLabel>
              {{
              (selectedConstraint ?
              'COMMON.CONSTRAINTS.' + selectedConstraint.type : 'COMMON.CONSTRAINTS.CHOICE') | translate
              }}
            </ng-template>
            <mat-form-field style="min-width: 300px">
              <mat-label>{{ 'COMMON.CONSTRAINTS.TYPE' | translate }}</mat-label>
              <mat-select formControlName="constraintType">
                @for (constraint of constraintTypes; track constraint) {
                  <mat-option [disabled]="constraint.disabled" [value]="constraint.type">
                    {{ 'COMMON.CONSTRAINTS.' + constraint.type | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </form>
        </mat-step>
        <!-- STEP 2: constraint settings -->
        <mat-step [stepControl]="secondStepGroup" state="constraintSettings">
          <form [formGroup]="secondStepGroup">
            <ng-template matStepLabel>{{ 'COMMON.CONSTRAINTS.PARAMETERS' | translate }}</ng-template>
            <ng-container *ngTemplateOutlet="constraintSettings;context:{form:secondStepGroup, constraint:selectedConstraint}"></ng-container>
          </form>
        </mat-step>
      </mat-stepper>
    } @else {
      @if (expanded) {
        <form [formGroup]="secondStepGroup">
          <ng-template matStepLabel>{{ 'COMMON.CONSTRAINTS.PARAMETERS' | translate }}</ng-template>
          <ng-container *ngTemplateOutlet="constraintSettings;context:{form:secondStepGroup, constraint:selectedConstraint}"></ng-container>
        </form>
      }
    }
  </mat-card-content>
  @if (expanded) {
    <mat-card-actions fxLayoutAlign="end center">
      @if (!existingConstraint && selectedConstraint) {
        <button mat-flat-button [disabled]="canValidConstraint === false" (click)="validNewConstraint(true)" color="primary">{{ 'SHARED.BUTTONS.ADD' | translate }}</button>
      }
      @if (existingConstraint) {
        @if (!selectedConstraint.mandatory) {
          <button mat-button (click)="deleteOldConstraint()" color="warn">{{ 'SHARED.BUTTONS.DELETE' | translate }}</button>
        }
        @if (selectedConstraint.type !== 'unknown') {
          <button mat-button (click)="updateOldConstraint()">{{ 'SHARED.BUTTONS.SAVE' | translate }}</button>
        }
      }
    </mat-card-actions>
  }
</mat-card>

<ng-template #constraintSettings let-form="form" let-constraint="constraint">

  @if (constraint?.parameters) {
    <div
      [formGroup]="form"
      fxLayout="row wrap" fxLayoutAlign="center center"
      class="constraint"
      [class.constraint-inline]="constraint?.parametersInline">
      @if (constraint.description) {
        <p>{{ 'COMMON.CONSTRAINTS.' + constraint.type + '.DESCRIPTION' | translate }}</p>
      }
      @for (parameterKeyValue of constraint.parameters | keyvalue; track parameterKeyValue) {
        <div
          fxFlex="0 0 100%"
          class="constraint-parameter">
          <ng-container *ngVar="parameterKeyValue.value as parameter">
            @switch (parameter.type) {
              <!-- STRING -->
              @case ('string') {
                <div>
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'COMMON.CONSTRAINTS.' + constraint.type + '.PARAMETER.' + parameterKeyValue.key | translate }}</mat-label>
                    <input matInput [formControlName]="parameterKeyValue.key" type="text">
                    @if (parameter.hint) {
                      <mat-hint>{{ 'COMMON.CONSTRAINTS.' + constraint.type + '.PARAMETER.' + parameterKeyValue.key + '.HINT' | translate }}</mat-hint>
                    }
                  </mat-form-field>
                </div>
              }
              <!-- END STRING -->
              <!-- NUMBER -->
              @case ('number') {
                <div>
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'COMMON.CONSTRAINTS.' + constraint.type + '.PARAMETER.' + parameterKeyValue.key | translate }}</mat-label>
                    <input matInput [formControlName]="parameterKeyValue.key" type="number" min="1" max="999" step="1">
                    @if (parameter.hint) {
                      <mat-hint>{{ 'COMMON.CONSTRAINTS.' + constraint.type + '.PARAMETER.' + parameterKeyValue.key + '.HINT' | translate }}</mat-hint>
                    }
                  </mat-form-field>
                </div>
              }
              <!-- END NUMBER -->
              <!-- BOOLEAN -->
              @case ('boolean') {
                <div>
                  <mat-checkbox [formControlName]="parameterKeyValue.key">
                    {{ 'COMMON.CONSTRAINTS.' + constraint.type + '.PARAMETER.' + parameterKeyValue.key | translate }}
                  </mat-checkbox>
                </div>
              }
              <!-- END BOOLEAN -->
              <!-- SELECT -->
              @case ('select') {
                <div>
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'COMMON.CONSTRAINTS.' + constraint.type + '.PARAMETER.' + parameterKeyValue.key | translate }}</mat-label>
                    <mat-select [formControlName]="parameterKeyValue.key">
                      @if (parameter?.choices?.length > 0) {
                        @for (opt of parameter.choices; track opt) {
                          <mat-option [value]="opt">{{ 'COMMON.CONSTRAINTS.' + constraint.type + '.PARAMETER.' + parameterKeyValue.key + '.' + parameter.viewChoices[$index] | translate }}</mat-option>
                          @if (parameter?.viewChoicesNegated?.length) {
                            <mat-option [value]="'!' + opt">{{ 'COMMON.CONSTRAINTS.' + constraint.type + '.PARAMETER.' + parameterKeyValue.key + '.' + parameter.viewChoicesNegated[$index] | translate }}</mat-option>
                          }
                        }
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!-- END SELECT -->
              <!-- CUSTOM -->
              @case ('custom') {
                <div>
                  @switch (parameterKeyValue.key) {
                    @case ('unknown') {
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'COMMON.CONSTRAINTS.' + constraint.type + '.PARAMETER.' + parameterKeyValue.key | translate }}</mat-label>
                        <input matInput [formControlName]="parameterKeyValue.key" type="text">
                        @if (parameter.hint) {
                          <mat-hint>{{ parameter.hint }}</mat-hint>
                        }
                      </mat-form-field>
                    }
                    @case ('withValue') {
                      @for (field of dynamicallyCreatedFields; track field) {
                        <div fxLayout="row" fxLayoutAlign="center center">
                          @if (fieldReady('withValue-name-' + field)) {
                            <mat-form-field fxFlex="0 0 40%" appearance="outline">
                              <mat-label>{{ 'COMMON.CONSTRAINTS.METADATA.NAME' | translate }}</mat-label>
                              <input matInput [formControlName]="'withValue-name-' + field" type="text">
                            </mat-form-field>
                          }
                          @if (fieldReady('withValue-val-' + field)) {
                            <mat-form-field fxFlex="0 0 40%" appearance="outline">
                              <mat-label>{{ 'COMMON.CONSTRAINTS.METADATA.VALUE' | translate }}</mat-label>
                              <input matInput [formControlName]="'withValue-val-' + field" type="text">
                            </mat-form-field>
                          }
                        </div>
                      }
                    }
                    @case ('withMetadata') {
                      @for (field of dynamicallyCreatedFields; track field) {
                        <div fxLayout="row" fxLayoutAlign="center center">
                          <div fxFlex="0 0 10%" class="dynamic-field-index">
                            #{{ $index + 1 }}
                          </div>
                          <mat-form-field fxFlex="0 0 60%" appearance="outline">
                            <mat-label>{{ 'COMMON.ENTITY.METADATA' | translate }}</mat-label>
                            <input matInput [formControlName]="'withMetadata-' + field" type="text">
                          </mat-form-field>
                        </div>
                      }
                    }
                    @case ('withCategory') {
                      @for (field of dynamicallyCreatedFields; track field) {
                        <div fxLayout="row" fxLayoutAlign="center center">
                          <div fxFlex="0 0 10%" class="dynamic-field-index">
                            #{{ $index + 1 }}
                          </div>
                          <mat-form-field fxFlex="0 0 60%" appearance="outline">
                            <mat-label>{{ 'COMMON.ENTITY.CATEGORY' | translate }}</mat-label>
                            <input matInput [formControlName]="'withCategory-' + field" type="text">
                          </mat-form-field>
                          <div fxFlex="0 0 10%" class="dynamic-field-index">
                            @if (dynamicallyCreatedFields.length > 1) {
                              <button
                                (click)="deleteField(parameterKeyValue.key, parameter, field)"
                                mat-icon-button color="warn"
                                [matTooltip]="'COMMON.CONSTRAINTS.CATEGORY.DELETE' | translate">
                                <mat-icon>clear</mat-icon>
                              </button>
                            }
                          </div>
                        </div>
                        @if ($index < dynamicallyCreatedFields.length - 1) {
                          <div fxLayout="row" fxLayoutAlign="center center" class="operator">
                            {{ (form.get('all-mandatory')?.value ? 'COMMON.WORDS.AND' : 'COMMON.WORDS.OR') | translate }}
                          </div>
                        }

                      }
                      <button mat-flat-button
                        [disabled]="containsEmptyDynamicField()"
                        (click)="addField(parameterKeyValue.key, parameter)">
                        {{ 'COMMON.CONSTRAINTS.CATEGORY.ADD' | translate }}
                      </button>
                    }
                    @case ('withURL') {
                      @for (field of dynamicallyCreatedFields; track field; let k = $index) {
                        <div fxLayout="row" fxLayoutAlign="center center">
                          <div fxFlex="0 0 10%" class="dynamic-field-index">
                            #{{ k + 1 }}
                          </div>
                          <mat-form-field fxFlex="0 0 60%" appearance="outline">
                            <mat-label>{{ 'COMMON.ENTITY.URL' | translate }}</mat-label>
                            <input matInput [formControlName]="'withURL-' + field" type="text">
                          </mat-form-field>
                          <div fxFlex="0 0 10%" class="dynamic-field-index">
                            @if (dynamicallyCreatedFields.length > 1) {
                              <button
                                (click)="deleteField(parameterKeyValue.key, parameter, field)"
                                mat-icon-button color="warn" [matTooltip]="'COMMON.CONSTRAINTS.URL.DELETE' | translate">
                                <mat-icon>clear</mat-icon>
                              </button>
                            }
                          </div>
                        </div>
                        @if ($index < dynamicallyCreatedFields.length - 1) {
                          <div fxLayout="row" fxLayoutAlign="center center" class="operator">
                            {{ 'COMMON.WORDS.OR' | translate }}
                          </div>
                        }

                      }
                      <button mat-flat-button
                        [disabled]="containsEmptyDynamicField()"
                        (click)="addField(parameterKeyValue.key, parameter)">
                        {{ 'COMMON.CONSTRAINTS.URL.ADD' | translate }}
                      </button>
                    }
                    @case ('withSource') {
                      @for (field of dynamicallyCreatedFields; track field; let k = $index) {
                        <div fxLayout="row" fxLayoutAlign="center center">
                          <div fxFlex="0 0 10%" class="dynamic-field-index">
                            #{{ k + 1 }}
                          </div>
                          <mat-form-field fxFlex="0 0 60%" appearance="outline">
                            <mat-label>{{ 'COMMON.ENTITY.ITEMFEED' | translate }}</mat-label>
                            <input matInput [formControlName]="'withSource-' + field" type="text">
                          </mat-form-field>
                          <div fxFlex="0 0 10%" class="dynamic-field-index">
                            @if (dynamicallyCreatedFields.length > 1) {
                              <button
                                (click)="deleteField(parameterKeyValue.key, parameter, field)"
                                mat-icon-button color="warn" [matTooltip]="'COMMON.CONSTRAINTS.ITEMFEED.DELETE' | translate">
                                <mat-icon>clear</mat-icon>
                              </button>
                            }
                          </div>
                        </div>
                      }
                      <button [disabled]="containsEmptyDynamicField()"
                        (click)="addField(parameterKeyValue.key, parameter)"
                        mat-flat-button>
                        {{ 'COMMON.CONSTRAINTS.ITEMFEED.ADD' | translate }}
                      </button>
                    }
                    @case ('exists-names') {
                      <div fxLayout="row">
                        <mat-form-field fxFlexOffset="25%" fxFlex="0 0 50%" appearance="outline">
                          <mat-label>{{ 'COMMON.ENTITY.METADATA' | translate }} n°1</mat-label>
                          <input matInput formControlName="exists-names-0" type="text">
                        </mat-form-field>
                      </div>
                      @for (field of dynamicallyCreatedFields; track field; let k = $index) {
                        <div fxLayout="row" fxLayoutAlign="center center">
                          <mat-form-field fxFlex="0 0 10%" appearance="outline">
                            <mat-label>{{ 'COMMON.WORDS.LINK' | translate }}</mat-label>
                            <mat-select [formControlName]="'exists-names-link-' + field">
                              <mat-option value="AND">{{ 'COMMON.WORDS.AND' | translate }}</mat-option>
                              <mat-option value="OR">{{ 'COMMON.WORDS.OR' | translate }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field fxFlex="0 0 50%" appearance="outline">
                            <mat-label>{{ 'COMMON.ENTITY.METADATA' | translate }} n°{{ k + 2 }}</mat-label>
                            <input matInput [formControlName]="'exists-names-' + field" type="text">
                          </mat-form-field>
                          <div fxFlex="0 0 10%">
                            @if (dynamicallyCreatedFields.length > 1) {
                              <button
                                (click)="deleteField(parameterKeyValue.key, parameter, field)"
                                mat-icon-button color="warn" [matTooltip]="'COMMON.CONSTRAINTS.METADATA.DELETE' | translate">
                                <mat-icon>clear</mat-icon>
                              </button>
                            }
                          </div>
                        </div>
                      }
                      <button mat-flat-button (click)="addField(parameterKeyValue.key, parameter)">
                        {{ 'COMMON.CONSTRAINTS.METADATA.ADD.MANDATORY' | translate }}
                      </button>
                    }
                    @case ('withConstraint') {
                      <!-- no sub constraint yet, CREATE -->
                      @if (!constraint.parameters['withConstraint'].value) {
                        <app-mediego-constraint
                          constraintsFor="itemset"
                          (addConstraint)="attachSubConstraint($event)"
                          [expanded]="true"
                          [minimal]="true">
                        </app-mediego-constraint>
                      } @else {
                        <!-- UPDATE -->
                        @if (editingSubConstraint) {
                          <app-mediego-constraint [existingConstraint]="constraint.parameters['withConstraint'].value"
                            constraintsFor="itemset"
                            (updateConstraint)="attachSubConstraint($event)"
                            [expanded]="true"
                            [minimal]="true"
                            [index]="0">
                          </app-mediego-constraint>
                        } @else {
                          <app-mediego-constraint-readonly [constraint]="constraint.parameters['withConstraint'].value">
                          </app-mediego-constraint-readonly>
                          <!-- button allowing for UPDATE -->
                          <button mat-icon-button (click)="editingSubConstraint = true" color="primary">
                            <mat-icon>settings</mat-icon>
                          </button>
                        }
                        <!-- READ -->
                      }
                      <!-- End of custom parameter 'withConstraint' -->
                    }
                  }
                </div>
              }
              <!-- END CUSTOM -->
              @default {
                <div>
                  {{ 'COMMON.CONSTRAINTS.UNRECOGNIZED' | translate }}
                </div>
              }
            }
          </ng-container>
        </div>
        } <!-- End .constraint-parameter -->
      </div>
    }

  </ng-template>
